// extracted by mini-css-extract-plugin
export default {"base":"vp_ZwzZh","checkmark":"vp_ge6YC","fill":"vp_J1Weo","scale":"vp_UISdX","circle":"vp_b0yZh","stroke":"vp_DQt1d","check":"vp__s2r7"};